import { get } from 'lodash'
import { infotecsSlice } from 'Pages/registratorCabinet'
import { Callback } from 'Src/types/utilTypes'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'

export class CustomerIdentificationChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}
	public work(data: SocketMessage) {
		const id = get(data?.message?.payload, 'id', null)
		const customer_identification_id = get(
			data?.message?.payload,
			'customer_identification_id',
			null
		)
		if (data?.message?.type === SocketMessageTypes.UPDATE_DOCUMENTS && id) {
			if (window?.location?.pathname?.includes('registration')) {
				this.dispatch(infotecsSlice.actions.infotecsReloadDataSocket({ id }))
			}
		}
		if (data?.message?.type === SocketMessageTypes.UPDATE_INFOTECS && customer_identification_id) {
			if (window?.location?.pathname?.includes('registration')) {
				this.dispatch(
					infotecsSlice.actions.getOne({
						id: customer_identification_id,
						reloadRbidosRequest: true,
					})
				)
			}
		}
	}
}
